module.exports = __webpack_public_path__ + "media/assets/images/trumbowyg_icons-7d13a291e3d00a5cf0824fde334eabfd.svg";